/**
 * The run detail as a permanent right-hand column (desktop).
 *
 * On a wide screen an overlay is the wrong primitive here: reading a run and
 * scanning the table are the same task, and a drawer forces the reader to close
 * one to see the other. Below `lg` this column is hidden and the drawer takes
 * over — see `BexioSyncRunDetailDrawer`.
 *
 * The body is `BexioSyncRunDetailContent`, exactly as the drawer uses it. This
 * file contributes a heading, a frame and the empty state, and no field of its
 * own.
 *
 * Sticky from `lg` up: the admin shell's own top bar is `lg:hidden`, so on the
 * widths where this column exists there is no fixed header for it to slide
 * under, and `top-6` lines up with the page's own `sm:p-6` padding.
 */
import React from "react";

import BexioSyncRunDetailContent from "./BexioSyncRunDetailContent";

export default function BexioSyncRunDetailPanel({ run, emptyHint }) {
  return (
    <aside
      aria-label="Laufdetails"
      className="hidden lg:sticky lg:top-6 lg:block lg:w-[340px] lg:shrink-0 lg:self-start xl:w-[380px]"
    >
      <div className="rounded-xl border border-border bg-card">
        <div className="border-b border-border px-4 py-3">
          <h2 className="text-sm font-semibold text-foreground">Laufdetails</h2>
        </div>
        <div className="space-y-4 p-4">
          {run ? (
            <BexioSyncRunDetailContent run={run} />
          ) : (
            /* With auto-selection in place this is reached only when the filtered
               window holds no runs at all — so it says that, rather than telling
               the reader to click something that is not there. */
            <p className="text-sm text-muted-foreground">
              {emptyHint || "Kein Sync-Lauf ausgewählt."}
            </p>
          )}
        </div>
      </div>
    </aside>
  );
}
